// @ts-nocheck
import React, { useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ReactComponent as FormatAlignLeftIcon } from '../../../../../assets/Icons/lucideIcons/text-align-start.svg';
import { ReactComponent as FormatAlignCenterIcon } from '../../../../../assets/Icons/lucideIcons/text-align-center.svg';
import { ReactComponent as FormatAlignRightIcon } from '../../../../../assets/Icons/lucideIcons/text-align-end.svg';
import PropTypes from 'prop-types';

import GroupWrapper from '../Wrappers/GroupWrapper';

const AlignmentGroup = ({ cellFormat, onFormatChange }) => {
  const handleAlignLeft = useCallback(() => {
    onFormatChange('alignLeft');
  }, [onFormatChange]);

  const handleAlignCenter = useCallback(() => {
    onFormatChange('alignCenter');
  }, [onFormatChange]);

  const handleAlignRight = useCallback(() => {
    onFormatChange('alignRight');
  }, [onFormatChange]);

  return (
    <GroupWrapper label="Alignment">
      <Tooltip title="Align Left">
        <IconButton
          size="small"
          onClick={handleAlignLeft}
          color={cellFormat?.textAlign === 'left' ? 'primary' : 'default'}
        >
          <FormatAlignLeftIcon width={18} height={18} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Align Center">
        <IconButton
          size="small"
          onClick={handleAlignCenter}
          color={cellFormat?.textAlign === 'center' ? 'primary' : 'default'}
        >
          <FormatAlignCenterIcon width={18} height={18} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Align Right">
        <IconButton
          size="small"
          onClick={handleAlignRight}
          color={cellFormat?.textAlign === 'right' ? 'primary' : 'default'}
        >
          <FormatAlignRightIcon width={18} height={18} />
        </IconButton>
      </Tooltip>
    </GroupWrapper>
  );
};

AlignmentGroup.propTypes = {
  cellFormat: PropTypes.shape({
    textAlign: PropTypes.string,
  }).isRequired,
  onFormatChange: PropTypes.func.isRequired,
};

export default AlignmentGroup;
